export const skiplinksThemes = {
    default: {
        menu: {
            padding: '12px 8px',
            borderRadius: '8px',
            ':focus-visible': { top: '8px', left: '8px' },
            ':focus-within': { top: '8px', left: '8px' },
        },
        link: {
            padding: '8px 12px',
            borderRadius: '40px',
        },
    },
};
